import { Component, OnInit, computed, input, signal } from '@angular/core'
import { HttpParams } from '@angular/common/http'
import { NgClass } from '@angular/common'

import { BaseComponent, QuarterlyMeasurableDashboard, QuarterlyMeasurableDashboardRow, Rock, formatQuarterlyMeasurableExact, formatQuarterlyMeasurableValue } from '../../shared'

@Component({
    selector: 'app-business-plan-dashboard',
    templateUrl: './business-plan-dashboard.component.html',
    styleUrls: ['./business-plan-dashboard.component.css'],
    standalone: true,
    imports: [NgClass],
})
export class BusinessPlanDashboardComponent extends BaseComponent implements OnInit {
    rocks = input<Rock[]>([])
    isLoadingRocks = input(false)

    dashboard = signal<QuarterlyMeasurableDashboard | null>(null)
    isLoadingDashboard = signal(true)
    dashboardLoadFailed = signal(false)

    rockStats = computed(() => {
        const items = this.rocks()
        const total = items.length
        const done = items.filter(r => r.status === 2).length
        const onTrack = items.filter(r => r.status === 1).length
        const offTrack = items.filter(r => r.status === 0).length
        const percentDone = total > 0 ? Math.round((done / total) * 100) : 0
        return { total, done, onTrack, offTrack, percentDone }
    })

    ngOnInit() {
        this.loadDashboard()
    }

    loadDashboard() {
        this.isLoadingDashboard.set(true)
        this.dashboardLoadFailed.set(false)
        const params = new HttpParams().set('quarterCount', '12')
        this.services.data.get<QuarterlyMeasurableDashboard>('/api/QuarterlyMeasurable/GetDashboard', params).subscribe({
            next: result => {
                this.dashboard.set(result)
                this.isLoadingDashboard.set(false)
            },
            error: () => {
                this.dashboardLoadFailed.set(true)
                this.isLoadingDashboard.set(false)
            },
        })
    }

    formatValue(row: QuarterlyMeasurableDashboardRow, value: number | null | undefined): string {
        return formatQuarterlyMeasurableValue(row.format, value, '—')
    }

    formatExact(value: number | null | undefined): string {
        return formatQuarterlyMeasurableExact(value)
    }

    getCellClass(row: QuarterlyMeasurableDashboardRow, value: number | null | undefined): string {
        if (value == null) {
            return ''
        }
        switch (row.goalDirection) {
            case 0:
                return value >= row.goalValue ? 'green-cell' : 'red-cell'
            case 1:
                return value <= row.goalValue ? 'green-cell' : 'red-cell'
            case 2:
                if (row.goalValue2 != null) {
                    return value >= row.goalValue && value <= row.goalValue2 ? 'green-cell' : 'red-cell'
                }
                return ''
            default:
                return ''
        }
    }

    getQuarterValue(row: QuarterlyMeasurableDashboardRow, quarterKey: string): number | null {
        const val = row.values[quarterKey]
        return val ?? null
    }
}
